import { Close } from "@material-ui/icons";
import AddIcon from "@mui/icons-material/Add";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Modal, Tooltip } from "@mui/material";
import { styled as MuiStyled } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";
import DraggableList from "react-draggable-list";
import { styled } from "styled-components";
import { colors } from "../../../../utils";
import { ASSETS } from "../../../../utils/config";
import Button from "../../../Button";
import ImageCropper from "../../../ImageCropper";
import ImageModal from "../../../ImageModal";
import Input from "../../../Input";
import TextView from "../../../TextView";
import MediaSelection from "../../Shared/MediaSelection";

const Container = styled.div`
  min-height: 40px;
  height: 6vh;
  align-items: center;
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: auto auto auto 1fr auto;
  grid-gap: 8px;
`;

const DragIcon = MuiStyled(DragIndicatorIcon)`
  font-weight: 600;
  font-size: 25px;
  cursor: grab;
  color: #bbbbbb;
`;

const Image = styled.img`
  width: 40px;
  height: 40px;
  border: 1px solid #667085;
  border-radius: 4px;
  object-fit: cover;
`;

const IconsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
  cursor: pointer;
  width: 100%;
  gap: 5px;
`;

const Icon = styled.img`
  height: 16px;
  width: 16px;
`;

const ModalContainer = styled.div`
  position: absolute;
  width: 400px;
  background-color: white;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  padding: 16px;
  border-radius: 8px;
  top: 50%;
  right: 10%;
  overflow: hidden;
`;

const AddIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e1e1e1;
  background-color: ${colors.background};
  margin: auto;
  cursor: pointer;
  margin-top: 10px;
`;

const ModalHeader = styled.div`
  display: flex;
  background-color: ${colors.background};
  justify-content: space-between;
  padding: 16px;
`;

const ModalContent = styled.div`
  padding: 16px;
`;

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 100px 80px;
  grid-gap: 10px;
  justify-content: flex-end;
`;
export default function List({
  images = [],
  setImages,
  shallowImages = [],
  setShallowImages,
  onClickAdd,
}) {
  const [openPreview, setOpenPreview] = useState(false);
  const [openMediaSelection, setOpenMediaSelection] = useState(false);
  const [openImageCropper, setOpenImageCropper] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const mediaRef = useRef(null);
  const containerRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mediaRef.current && !mediaRef.current.contains(event.target)) {
        setOpenMediaSelection(false);
        setCurrentItem(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mediaRef]);

  const _onListChange = (newList) => {
    setImages(newList);
  };

  const handleOpenMediaSelection = (item) => {
    setCurrentItem(item);
    setOpenMediaSelection(true);
  };

  const handleOpenImageCropper = (item) => {
    setCurrentItem(item);
    setOpenImageCropper(true);
  };

  const handleOpenPreview = (item) => {
    setCurrentItem(item);
    setOpenPreview(true);
  };

  const handleTitleChange = (id, value) => {
    const temp = [...images];
    const index = temp.findIndex((val) => val.id == id);
    temp[index] = { ...temp[index], title: value };
    setImages(temp);
  };

  const onDeleteItem = (id) => {
    setImages(images.filter((image) => image.id !== id));
    setShallowImages(shallowImages.filter((image) => image.id !== id));
  };

  const updateItemInArray = (array, itemId, newItemData) => {
    const index = array.findIndex((item) => item.id === itemId);
    if (index !== -1) {
      const updatedArray = [...array];
      updatedArray[index] = { ...updatedArray[index], ...newItemData };
      return updatedArray;
    }
    return array;
  };

  const onReplaceItem = (_, value) => {
    const newImage = typeof value === "string" ? { src: value } : value;

    const updatedImages = updateItemInArray(images, currentItem.id, newImage);
    setImages(updatedImages);

    const updatedShallowImages = updateItemInArray(
      shallowImages,
      currentItem.id,
      newImage
    );
    setShallowImages(updatedShallowImages);

    setOpenMediaSelection(false);
  };

  const handleEditImage = (image) => {
    const temp = [...images];
    const index = temp.findIndex((val) => val.id == currentItem.id);
    temp[index] = { ...temp[index], src: image };
    setImages(temp);
    setOpenMediaSelection(false);
  };

  const ListTemplate = ({ item, index, dragHandleProps }) => {
    const { onMouseDown, onTouchStart } = dragHandleProps;
    const [title, setTitle] = useState(item.title);
    const [openTitlePopup, setOpenTitlePopup] = useState(false);

    const handleChange = (e) => {
      const { value } = e.target;
      handleTitleChange(item.id, value);
    };

    return (
      <div>
        <Container>
          <span
            style={{
              fontFamily: "DM Sans",
              fontSize: "12px",
              fontWeight: 400,
              color: "#565556",
            }}
          >
            {" "}
            {index + 1}
          </span>
          <DragIcon
            className="disable-select dragHandle"
            onTouchStart={(e) => {
              e.preventDefault();
              e.target.style.backgroundColor = "blue";
              document.body.style.overflow = "hidden";
              onTouchStart(e);
            }}
            onMouseDown={(e) => {
              document.body.style.overflow = "hidden";
              onMouseDown(e);
            }}
            onTouchEnd={(e) => {
              e.target.style.backgroundColor = "black";
              document.body.style.overflow = "visible";
            }}
            onMouseUp={() => {
              document.body.style.overflow = "visible";
            }}
          />

          <Image src={item.src} />

          <TextView>{item.title || "Untitled image"}</TextView>
          <IconsContainer>
            <Tooltip title="Edit Title">
              <Icon
                src={ASSETS.segmentEditor.EditPencil}
                onClick={() => setOpenTitlePopup(true)}
              />
            </Tooltip>
            <Tooltip title="Edit Image">
              <Icon
                src={ASSETS.EditImage}
                onClick={() => handleOpenImageCropper(item)}
              />
            </Tooltip>
            <Tooltip title="Preview Image">
              <Icon
                src={ASSETS.segmentEditor.ViewV2}
                onClick={() => handleOpenPreview(item)}
              />
            </Tooltip>
            <Tooltip title="Replace Image">
              <Icon
                src={ASSETS.segmentEditor.ReplaceImage}
                onClick={() => handleOpenMediaSelection(item)}
              />
            </Tooltip>
            <Tooltip title="Delete Image">
              <Icon
                src={ASSETS.segmentEditor.DeleteOutline}
                onClick={() => onDeleteItem(item.id)}
              />
            </Tooltip>
          </IconsContainer>
        </Container>
        {openTitlePopup && (
          <Modal open={openTitlePopup} onClose={() => setOpenTitlePopup(false)}>
            <ModalContainer style={{ padding: 0 }}>
              <ModalHeader>
                <TextView variant="subtitle">Edit Document Name</TextView>
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={() => setOpenTitlePopup(false)}
                />
              </ModalHeader>
              <ModalContent>
                <Input
                  variant={"secondary"}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <ButtonsContainer>
                  <Button
                    variant={"secondary"}
                    onClick={() => setOpenTitlePopup(false)}
                  >
                    Cancel
                  </Button>
                  <Button onClick={() => handleTitleChange(item.id, title)}>
                    Save
                  </Button>
                </ButtonsContainer>
              </ModalContent>
            </ModalContainer>
          </Modal>
        )}
      </div>
    );
  };

  return (
    <div>
      <DraggableList
        itemKey="id"
        // template={ListTemplate}
        template={(props) => (
          <ListTemplate
            {...props}
            index={images.findIndex((i) => i.id === props.item.id)}
          />
        )}
        list={images}
        onMoveEnd={(newList) => _onListChange(newList)}
        container={() => containerRef.current}
      />

      <AddIconContainer onClick={onClickAdd}>
        <AddIcon style={{ color: colors.purple }} />
      </AddIconContainer>

      {currentItem && (
        <>
          <ImageModal
            open={openPreview}
            images={[currentItem]}
            handleClose={() => setOpenPreview(false)}
          />

          <Modal
            open={openMediaSelection}
            onClose={() => setOpenMediaSelection(false)}
          >
            <ModalContainer>
              <MediaSelection
                type="image"
                isGifAllowed
                handleChange={onReplaceItem}
                media={currentItem}
              />
            </ModalContainer>
          </Modal>
          <ImageCropper
            open={openImageCropper}
            handleClose={() => setOpenImageCropper(false)}
            src={currentItem?.src}
            handleEditImage={handleEditImage}
          />
        </>
      )}
    </div>
  );
}
